import Skeleton from "./Skeleton";
import { SectionTitleSkeleton } from "../ui/SectionTitle";

/**
 * Loading silhouette for the Discovery "Collections for you" carousel
 * (CollectionsSection): the title-badge + "See all" row, then a wide playlist
 * card (h-28 = 112px, rounded-2xl = 16px) with the next peeking, matching the
 * `basis-[95%]` snap cards.
 */
export default function DiscoveryCollectionsSkeleton(): React.JSX.Element {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-between gap-3 px-5">
        <SectionTitleSkeleton width={140} />
        {/* "See all" link. */}
        <Skeleton $variant="rectangular" width={48} height={16} />
      </div>
      <div className="flex gap-3 px-5">
        <Skeleton className="shrink-0 rounded-2xl" width="92%" height={112} />
        <Skeleton className="shrink-0 rounded-2xl" width="92%" height={112} />
      </div>
    </div>
  );
}
